import { createSlice } from "@reduxjs/toolkit";
import { RequestStatus as Status } from "constants/RequestStatus";
import reducers from "./reducers";
import { TemplateState } from "../../types/Template";

const initialState: TemplateState = {
    loading: false,
    templates: [],
    saveTemplateRequestStatus: Status.Loading,
  };
  
  export const templateSlice = createSlice({
    name: "templates",
    initialState,
    reducers,
  });
  
  export const { setSaveTemplateRequestStatus, setTemplates } = templateSlice.actions;
  
  export default templateSlice.reducer;